<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${warehouse.name}` }} - {{ $t("COMMON.SALES_PRICING") }}
      </span>
    </div>

    <warehouse-sales-pricing-list :warehouse="warehouse" />
  </div>
</template>

<script>
import WarehouseSalesPricingList from "@/components/WarehouseProduct/WarehouseSalesPricingList.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  name: "warehouse-view-sales-pricing",

  components: {
    WarehouseSalesPricingList,
  },

  props: ["warehouse"],

  mixins: [requestErrorMixin],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {},
};
</script>
